<template lang="pug">
	section.section.main-section
		.container
			title-comp(:name="$t('title.account_auth')")

			.form-container.form-login
				.hourglass-outer(v-if="loadingState")
					hourglass
				div(v-else)
					.columns.is-centered.is-vcentered
						.column
							strong {{ $t('placeholder.name') }}
						.column
							p {{ userProfile.first_name + ' ' + userProfile.last_name }}
					.columns.is-centered.is-vcentered(v-if="userProfile.email")
						.column
							strong {{ $t('placeholder.email') }}
						.column
							p {{ userProfile.email }}
					.columns.is-centered.is-vcentered
						.column
							strong {{ $t('placeholder.password') }}
						.column
							router-link(:to="urlPassword")
								| {{ $t('button.update_password') }}

</template>

<script>
import HourglassComponent from '../components/HourglassComponent.vue'
import TitleComponent from '../components/TitleComponent.vue'

export default {
	components: {
		TitleComp: TitleComponent,
		Hourglass: HourglassComponent
	},
	data() {
		return {
			loadingLogin: false,
			loadingState: false,
			emptyPage   : false,
			errorPage   : false
		}
	},
	props: {
		showing : Boolean
	},
	computed: {
		accessToken() {
			return this.$store.state.auth.accessToken
		},
		tokenType() {
			return this.$store.state.auth.accessToken ? (this.$store.state.auth.tokenType || 'user') : null
		},
		loading() {
			return this.$store.state.auth.loading
		},
		buttonClass() {
			return { 'is-loading': this.loading }
		},
		urlHome() {
			return '/' + this.$route.params.language
		},
		urlProfile() {
			return '/' + this.$route.params.language + '/profile'
		},
		userProfile() {
			return this.$store.state.user.userProfile
		},
		urlPassword() {
			return '/' + this.$route.params.language + '/panel/password'
		}
	},
	mounted() {
		this.$meta().setOptions({ title: this.$t("title.account_auth") + ' | ' + this.$t("title.home") })
		if (!this.accessToken) {
			this.$router.replace('/' + this.$route.params.language)
		} else {
			this.prepareRoute(this.$route, this.userProfile)
		}
	},
	methods: {
		prepareRoute(to, userProfile) {
			if (userProfile === null) {
				return this.loadUserProfile()
			}
			//console.log(userProfile)
			//this.$store.commit('user/SET_AUTH_RESTORE_PASSWORD', true)
		},
		loadUserProfile() {
			this.loadingState = true
			return this.$store.dispatch('user/getUserProfile', this.accessToken)
				.then(res => {
					this.emptyPage = false
					this.errorPage = false
					this.loadingState = false
				})
				.catch(err => {
					this.loadingState = false
					if (err.response && err.response.status) {
						switch (err.response.status) {
							case 403:
								if (err.response.data && err.response.data.error_message === 'Access Token Expired') {
									this.$store.dispatch('auth/clearToken').then(() => {
										this.$router.replace('/' + this.$route.params.language + '/login')
									})
									return
								}
								break
							case 404:
								this.emptyPage = true
								break
							case 500:
								this.errorPage = true
								break
							default:
								console.warn(err.response.status)
						}
					} else {
						console.warn(err)
					}
				})
		}
	},
	watch: {
		/*'$route' (to, from) {
			this.prepareRoute(to, this.userProfile)
		},*/
		userProfile (to, from) {
			this.prepareRoute(this.$route, to)
		}
	}
}
</script>
